import { createDraftSafeSelector as createSelector } from '@reduxjs/toolkit';

import { Inject } from '@vk-hr-tek/core/ioc';

import { RootState } from '../../app/store';
import { LayoutMapper } from '../mappers';

export const selectServiceUnavailable = (state: RootState) =>
  state.layout.isServiceUnavailable;

export const selectSidebarState = (state: RootState) =>
  state.layout.sidebarState;

export const selectIsLogoLoaded = (state: RootState) =>
  state.layout.isLogoLoaded;

export const selectSearchStatus = (state: RootState) =>
  state.layout.search.status;

export const selectSearchItems = createSelector(
  [
    (state: RootState) => state.layout.search.items,
    (state: RootState) => state.layout.search.group,
    (_: RootState, inject: Inject) => inject(LayoutMapper),
  ],
  (searchItems, group, format) =>
    searchItems ? format.processSearchItems(searchItems, group) : [],
);

export const selectSideMenu = (state: RootState) =>
  state.layout.sideMenuState?.menu;
